import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import MaterialInput from '@/components/MaterialInput/index.vue';
import Sticky from '@/components/Sticky/index.vue';
import Tinymce from '@/components/Tinymce/index.vue';
import { createMissionInfoQuiz, updateMissionInfoQuiz, getMissionInfoQuiz } from '@/api/missionInfoQuiz';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "quiz", void 0);
    _defineProperty(_this, "title", void 0);
    _defineProperty(_this, "visible", void 0);
    _defineProperty(_this, "action", void 0);
    _defineProperty(_this, "isEdit", void 0);
    _defineProperty(_this, "quizeTypes", [{
      label: 'OX',
      value: 'OX'
    }, {
      label: 'Choice',
      value: 'CHOICE'
    }, {
      label: 'Subjective',
      value: 'SUBJECTIVE'
    }]);
    _defineProperty(_this, "answerTypes", []);
    _defineProperty(_this, "answerString", '');
    _defineProperty(_this, "defaultOX", [{
      label: 'O',
      value: 'O'
    }, {
      label: 'X',
      value: 'X'
    }]);
    _defineProperty(_this, "defaultChoice", [{
      label: '1',
      value: '1'
    }, {
      label: '2',
      value: '2'
    }, {
      label: '3',
      value: '3'
    }, {
      label: '4',
      value: '4'
    }]);
    _defineProperty(_this, "validateRequire", function (rule, value, callback) {
      if (value === '') {
        _this.$message({
          message: rule.field + ' is required',
          type: 'error'
        });
        callback(new Error(rule.field + ' is required'));
      } else {
        callback();
      }
    });
    _defineProperty(_this, "postForm", Object.assign({}, _this.quiz));
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "rules", {
      title: [{
        validator: _this.validateRequire
      }],
      content: [{
        validator: _this.validateRequire
      }]
    });
    _defineProperty(_this, "tinymceActive", true);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "handleClose",
    value: function handleClose() {
      this.tinymceActive = false;
      this.$emit('update:visible', false);
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      var form = this.$refs['dataForm'];
      if (form) form.resetFields();
      console.log('asdfasdfasdf : ', this.quiz);
      this.defaultChoice = [{
        label: '1',
        value: '1'
      }, {
        label: '2',
        value: '2'
      }, {
        label: '3',
        value: '3'
      }, {
        label: '4',
        value: '4'
      }];
      this.tinymceActive = true;
      this.postForm = Object.assign({}, this.quiz);
      this.fetchData();
    }
  }, {
    key: "quizTypeChange",
    value: function quizTypeChange(val) {
      if (val === 'OX') {
        this.answerTypes = this.defaultOX;
        this.answerString = this.defaultOX[0].value;
      } else if (val === 'CHOICE') {
        this.answerTypes = this.defaultChoice;
        this.answerString = this.defaultChoice[0].value;
      } else {
        this.answerString = '';
      }
    }
  }, {
    key: "titleColSpan",
    value: function titleColSpan() {
      if (this.postForm.id) {
        return 8;
      }
      return 12;
    }
  }, {
    key: "lang",
    get: function get() {
      return AppModule.language;
    }
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var reading, temp;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.quiz.id) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return getMissionInfoQuiz(this.quiz.missionInfoId, this.quiz.id);
            case 1:
              reading = _context.v;
              if (reading.answerList !== null && reading.answerList !== undefined) {
                temp = reading.answerList.find(function (item) {
                  return item.is_answer === true;
                });
                this.answerString = temp.text;
                if (reading.quizType === 'CHOICE') {
                  this.defaultChoice = reading.answerList.map(function (item) {
                    return {
                      label: item.text,
                      value: item.text
                    };
                  });
                }
              }
              this.postForm = reading;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }, {
    key: "submitForm",
    value: function submitForm() {
      var _this2 = this;
      var $this = this;
      this.$refs.postForm.validate(function (valid) {
        if (valid) {
          // $this.loading = true
          console.log('저장');
          console.log('postForm : ', _this2.postForm);
          if (_this2.postForm.onlyAnswer === false) {
            if (_this2.postForm.quizType === 'OX') {
              _this2.postForm.answerList = _this2.answerTypes.map(function (item, index) {
                return {
                  text: item.value,
                  is_answer: item.value === _this2.answerString,
                  order: index
                };
              });
            } else if (_this2.postForm.quizType === 'CHOICE') {
              _this2.postForm.answerList = _this2.defaultChoice.map(function (item, index) {
                return {
                  text: item.value,
                  is_answer: item.value === _this2.answerString,
                  order: index
                };
              });
            } else {
              _this2.postForm.answerList = null;
            }
          } else {
            _this2.postForm.answerList = null;
            _this2.postForm.quizType = null;
          }
          if (_this2.postForm.quizType === 'CHOICE' && _this2.postForm.answerList.find(function (item) {
            return item.is_answer === true;
          }) === undefined) {
            $this.$notify({
              title: 'Error',
              message: 'There are no answers in the list.',
              type: 'error',
              duration: 2000
            });
            return false;
          }
          var promise = null;
          if ($this.postForm.id) {
            promise = updateMissionInfoQuiz($this.postForm);
          } else {
            promise = createMissionInfoQuiz($this.postForm);
          }
          promise.then(function (res) {
            $this.$notify({
              title: 'Success',
              message: 'Saved successfully',
              type: 'success',
              duration: 2000
            });
            $this.postForm = res;
            if ($this.postForm.quizType === 'OX' || $this.postForm.quizType === 'CHOICE') {
              var temp = $this.postForm.answerList.find(function (item) {
                return item.is_answer === true;
              });
              $this.answerString = temp.text;
            }
            $this.loading = false;
          }).catch(function (err) {
            $this.$notify({
              title: 'Error',
              message: 'Failed to Saved',
              type: 'error',
              duration: 2000
            });
            console.error(err);
            $this.loading = false;
          });
        } else {
          console.error('Submit Error!');
          return false;
        }
      });
    }
  }]);
}(Vue);
__decorate([Prop({
  required: false
})], default_1.prototype, "quiz", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "title", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "visible", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "action", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Watch('postForm.quizType')], default_1.prototype, "quizTypeChange", null);
default_1 = __decorate([Component({
  name: 'WriteQuiz',
  components: {
    MaterialInput: MaterialInput,
    Sticky: Sticky,
    Tinymce: Tinymce
  }
})], default_1);
export default default_1;